var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AccountBalance, BadgeOutlined } from "@mui/icons-material";
import { Box, Divider, Grid, IconButton, MenuItem, Select, Typography } from "@mui/material";
import * as React from "react";
import CustomTextField from "@/components/Input/CustomTextField";
import { fetchProfileRequest } from "@/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import BackDropComponent from "@/components/BackDrop";
import APIIN from "@/utils/APIIN";
import DownloadIcon from "@mui/icons-material/Download";
import { enqueueSnackbar } from "notistack";
const documentsType = ["Aadhaar", "Passport", "PanCard", "DrivingLicense"];
const KycDetailsForm = () => {
    const childRef = React.useRef(null);
    const [countryList, setCountryList] = React.useState([]);
    const countryState = useSelector((state) => state.countryReducer);
    const dispatch = useDispatch();
    const [selectedAccountType, setSelectedAccountType] = React.useState("");
    const [documentType, setDocumentType] = React.useState("Aadhaar");
    const [panCardNumber, setPanCardNumber] = React.useState("");
    const [panName, setPanName] = React.useState("");
    const [documentId, setDocumentId] = React.useState("");
    const [documentName, setDocumentName] = React.useState("");
    const [coiNumber, setCoiNumber] = React.useState("");
    const [isBackOpenOpen, setIsBackOpenOpen] = React.useState(false);
    const tenantId = localStorage.getItem("tenantId");
    const [beneficiaryName, setBeneficiaryName] = React.useState("");
    const [accountNumber, setAccountNumber] = React.useState("");
    const [ifscCode, setIfscCode] = React.useState("");
    const [bankName, setBankName] = React.useState("");
    const handleDownload = (data, fileType, extension) => {
        const type = extension === "png" ? "images/png" : "application/" + extension;
        const blobData = new Blob([data], { type: type });
        const url = window.URL.createObjectURL(blobData);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${fileType}.${extension}`;
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
    };
    const downloadFile = (fileType, fileName) => __awaiter(void 0, void 0, void 0, function* () {
        return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                APIIN.downloadLabel(`/company/admin/kyc/file/download?fileType=${fileType}&companyId=${tenantId}`)
                    .then((data) => {
                    var _a;
                    const extension = ((_a = fileName === null || fileName === void 0 ? void 0 : fileName.split(".")) === null || _a === void 0 ? void 0 : _a.length) > 1 ? fileName === null || fileName === void 0 ? void 0 : fileName.split(".")[1] : "png";
                    handleDownload(data, fileType, extension);
                    resolve(data);
                })
                    .catch((error) => {
                    reject(error);
                });
            }
            catch (error) {
                if (error instanceof Error) {
                    reject(error);
                }
            }
        }));
    });
    React.useEffect(() => {
        if (countryState && countryState.data) {
            setCountryList(countryState.data);
        }
        else if (countryState.error) {
            if (countryState.error instanceof Error) {
                enqueueSnackbar(countryState.error, { variant: "error" });
            }
        }
    }, [countryState]);
    const [panCardFileName, setPanCardFileName] = React.useState(null);
    const [panCardFileType, setPanCardFileType] = React.useState(null);
    const [docFrontFileName, setDocFrontFileName] = React.useState(null);
    const [docFrontFileType, setDocFrontFileType] = React.useState(null);
    const [docBackFileName, setDocBackFileName] = React.useState(null);
    const [docBackFileType, setDocBackFileType] = React.useState(null);
    const [partnershipFileName, setPartnershipFileName] = React.useState(null);
    const [partnershipFileType, setPartnershipFileType] = React.useState(null);
    const [coiImageFileName, setCoiImageFileName] = React.useState(null);
    const [coiImageFileType, setCoiImageFileType] = React.useState(null);
    const getProfileState = useSelector((state) => state.getProfilesReducer);
    React.useEffect(() => {
        handleResetClick();
        dispatch(fetchProfileRequest({ companyId: tenantId }));
    }, [tenantId]);
    const handleResetClick = () => {
        setSelectedAccountType("");
        setPanCardNumber("");
        setPanName("");
        setDocumentType("");
        setDocumentId("");
        setDocumentName("");
        setPanCardFileName("");
        setPanCardFileType("");
        setDocFrontFileName("");
        setDocFrontFileType("");
        setDocBackFileName("");
        setDocBackFileType("");
        setPartnershipFileName("");
        setPartnershipFileType("");
        setCoiNumber("");
        setCoiImageFileName("");
        setCoiImageFileType("");
    };
    React.useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
        if (getProfileState.data) {
            const kycData = (_a = getProfileState === null || getProfileState === void 0 ? void 0 : getProfileState.data) === null || _a === void 0 ? void 0 : _a.kycInfo;
            const bankData = (_b = getProfileState === null || getProfileState === void 0 ? void 0 : getProfileState.data) === null || _b === void 0 ? void 0 : _b.bankInfo;
            setSelectedAccountType(kycData === null || kycData === void 0 ? void 0 : kycData.accountType);
            setPanCardNumber((_c = kycData === null || kycData === void 0 ? void 0 : kycData.panCardDetails) === null || _c === void 0 ? void 0 : _c.number);
            setPanName((_d = kycData === null || kycData === void 0 ? void 0 : kycData.panCardDetails) === null || _d === void 0 ? void 0 : _d.name);
            setDocumentType((_e = kycData === null || kycData === void 0 ? void 0 : kycData.addressProofDetails) === null || _e === void 0 ? void 0 : _e.documentType);
            setDocumentId((_f = kycData === null || kycData === void 0 ? void 0 : kycData.addressProofDetails) === null || _f === void 0 ? void 0 : _f.documentId);
            setDocumentName((_g = kycData === null || kycData === void 0 ? void 0 : kycData.addressProofDetails) === null || _g === void 0 ? void 0 : _g.nameOnDocument);
            setPanCardFileName((_j = (_h = kycData === null || kycData === void 0 ? void 0 : kycData.panCardDetails) === null || _h === void 0 ? void 0 : _h.panCardFile) === null || _j === void 0 ? void 0 : _j.fileName);
            setPanCardFileType((_l = (_k = kycData === null || kycData === void 0 ? void 0 : kycData.panCardDetails) === null || _k === void 0 ? void 0 : _k.panCardFile) === null || _l === void 0 ? void 0 : _l.fileType);
            setDocFrontFileName((_o = (_m = kycData === null || kycData === void 0 ? void 0 : kycData.addressProofDetails) === null || _m === void 0 ? void 0 : _m.frontImageFileDetails) === null || _o === void 0 ? void 0 : _o.fileName);
            setDocFrontFileType((_q = (_p = kycData === null || kycData === void 0 ? void 0 : kycData.addressProofDetails) === null || _p === void 0 ? void 0 : _p.frontImageFileDetails) === null || _q === void 0 ? void 0 : _q.fileType);
            setDocBackFileName((_s = (_r = kycData === null || kycData === void 0 ? void 0 : kycData.addressProofDetails) === null || _r === void 0 ? void 0 : _r.backImageFileDetails) === null || _s === void 0 ? void 0 : _s.fileName);
            setDocBackFileType((_u = (_t = kycData === null || kycData === void 0 ? void 0 : kycData.addressProofDetails) === null || _t === void 0 ? void 0 : _t.backImageFileDetails) === null || _u === void 0 ? void 0 : _u.fileType);
            setPartnershipFileName((_v = kycData === null || kycData === void 0 ? void 0 : kycData.supportFileDetails) === null || _v === void 0 ? void 0 : _v.fileName);
            setPartnershipFileType((_w = kycData === null || kycData === void 0 ? void 0 : kycData.supportFileDetails) === null || _w === void 0 ? void 0 : _w.fileType);
            setCoiNumber((_x = kycData === null || kycData === void 0 ? void 0 : kycData.coiDetails) === null || _x === void 0 ? void 0 : _x.coiNumber);
            setCoiImageFileName((_z = (_y = kycData === null || kycData === void 0 ? void 0 : kycData.coiDetails) === null || _y === void 0 ? void 0 : _y.coiFileDetails) === null || _z === void 0 ? void 0 : _z.fileName);
            setCoiImageFileType((_1 = (_0 = kycData === null || kycData === void 0 ? void 0 : kycData.coiDetails) === null || _0 === void 0 ? void 0 : _0.coiFileDetails) === null || _1 === void 0 ? void 0 : _1.fileType);
            setAccountNumber((bankData === null || bankData === void 0 ? void 0 : bankData.accountNumber) ? bankData === null || bankData === void 0 ? void 0 : bankData.accountNumber : "");
            setBeneficiaryName((bankData === null || bankData === void 0 ? void 0 : bankData.beneficiaryName) ? bankData === null || bankData === void 0 ? void 0 : bankData.beneficiaryName : "");
            setIfscCode((bankData === null || bankData === void 0 ? void 0 : bankData.ifscCode) ? bankData === null || bankData === void 0 ? void 0 : bankData.ifscCode : "");
            setBankName((bankData === null || bankData === void 0 ? void 0 : bankData.bankName) ? bankData === null || bankData === void 0 ? void 0 : bankData.bankName : "");
        }
    }, [getProfileState]);
    const renderFileChip = (fileName, fileType) => {
        if (!fileName) {
            return (React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 12, color: "#94A3B8", mt: 0.5 } }, "Not uploaded"));
        }
        const ext = (fileName.split(".").pop() || "").toUpperCase();
        const isPdf = fileName.toLowerCase().includes("pdf");
        return (React.createElement(Box, { sx: {
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                px: 1.25,
                py: 0.75,
                backgroundColor: "#F8FAFC",
                borderRadius: "8px",
                border: "1px solid #E2E8F0",
                maxWidth: "100%",
            } },
            React.createElement(Box, { sx: {
                    width: 28,
                    height: 32,
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    backgroundColor: isPdf ? "#FEF2F2" : "#EFF6FF",
                } },
                React.createElement(Typography, { sx: {
                        fontSize: 7,
                        fontWeight: 800,
                        fontFamily: "monospace",
                        color: isPdf ? "#B91C1C" : "#1D4ED8",
                        letterSpacing: 0,
                    } }, ext)),
            React.createElement(Typography, { sx: {
                    fontFamily: "Poppins",
                    fontSize: 12,
                    color: "#334155",
                    fontWeight: 500,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: 160,
                } }, fileName),
            React.createElement(IconButton, { size: "small", onClick: () => downloadFile(fileType, fileName), sx: {
                    p: 0.5,
                    color: "#64748B",
                    borderRadius: "6px",
                    flexShrink: 0,
                    "&:hover": { color: "#1D4ED8", backgroundColor: "#EFF6FF" },
                } },
                React.createElement(DownloadIcon, { sx: { fontSize: 15 } }))));
    };
    const fieldSx = {
        "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            backgroundColor: "#F8FAFC",
            fontFamily: "Poppins",
            fontSize: 13,
        },
    };
    return (React.createElement(Grid, { container: true, direction: "column", spacing: 0 },
        React.createElement(BackDropComponent, { open: isBackOpenOpen }),
        React.createElement(Grid, { item: true },
            React.createElement(Box, { sx: { border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden", mb: 2.5 } },
                React.createElement(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        px: 2.5,
                        py: 1.75,
                        backgroundColor: "#F8FAFC",
                        borderBottom: "1px solid #E2E8F0",
                    } },
                    React.createElement(Box, { sx: {
                            width: 36,
                            height: 36,
                            borderRadius: "9px",
                            backgroundColor: "#EFF6FF",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                        } },
                        React.createElement(BadgeOutlined, { sx: { fontSize: 20, color: "#1D4ED8" } })),
                    React.createElement(Box, null,
                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 14, fontWeight: 600, color: "#0f172a", lineHeight: 1.3 } }, "KYC by uploading ID & address proofs"),
                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 11, color: "#64748B", lineHeight: 1.5 } }, "Identity and address verification documents"))),
                React.createElement(Box, { sx: { p: 2.5 } },
                    React.createElement(Box, { sx: { mb: 2.5 } },
                        React.createElement(Typography, { className: "tenant_key", mb: 0.75 }, "Account Type"),
                        selectedAccountType ? (React.createElement(Box, { sx: {
                                display: "inline-flex",
                                alignItems: "center",
                                px: 1.5,
                                py: 0.6,
                                borderRadius: "8px",
                                fontSize: 13,
                                fontWeight: 600,
                                fontFamily: "Poppins",
                                backgroundColor: "#EFF6FF",
                                color: "#1D4ED8",
                                border: "1px solid #BFDBFE",
                            } }, selectedAccountType
                            .split("_")
                            .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
                            .join(" "))) : (React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 13, color: "#94A3B8" } }, "\u2014"))),
                    React.createElement(Divider, { sx: { borderColor: "#F1F5F9", mb: 2.5 } }),
                    React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 13, fontWeight: 600, color: "#0f172a", mb: 2 } }, "PAN Card Details"),
                    React.createElement(Grid, { container: true, spacing: 2.5, mb: 2.5 },
                        React.createElement(Grid, { item: true, xs: 5 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 },
                                selectedAccountType !== "sole_proprietorship" && "Company ",
                                "PAN Card Number"),
                            React.createElement(CustomTextField, { className: "AO_input_background", InputLabelProps: { shrink: false }, inputProps: { maxLength: 10, minLength: 10 }, placeholder: "ABCDE12239", disabled: true, fullWidth: true, name: "panCardNumber", size: "small", value: panCardNumber, sx: fieldSx })),
                        React.createElement(Grid, { item: true, xs: 4 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Name on PAN Card"),
                            React.createElement(CustomTextField, { className: "AO_input_background", InputLabelProps: { shrink: false }, inputProps: { maxLength: 30, minLength: 2 }, placeholder: "Enter name", disabled: true, fullWidth: true, name: "panName", size: "small", value: panName, sx: fieldSx })),
                        React.createElement(Grid, { item: true, xs: 3 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "PAN Card File"),
                            renderFileChip(panCardFileName, panCardFileType))),
                    (selectedAccountType === "partnership" || selectedAccountType === "limited_liability_partnership") && (React.createElement(Grid, { container: true, spacing: 2.5, mb: 2.5 },
                        React.createElement(Grid, { item: true, xs: 4 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Partnership Deed"),
                            renderFileChip(partnershipFileName, partnershipFileType)))),
                    (selectedAccountType === "private_limited_company" || selectedAccountType === "public_limited_company") && (React.createElement(Grid, { container: true, spacing: 2.5, mb: 2.5 },
                        React.createElement(Grid, { item: true, xs: 4 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "COI Number"),
                            React.createElement(CustomTextField, { className: "AO_input_background", InputLabelProps: { shrink: false }, inputProps: { maxLength: 30, minLength: 2 }, disabled: true, placeholder: "Enter COI", fullWidth: true, name: "coiNumber", size: "small", value: coiNumber, sx: fieldSx })),
                        React.createElement(Grid, { item: true, xs: 4 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "COI Document"),
                            renderFileChip(coiImageFileName, coiImageFileType)))),
                    React.createElement(Divider, { sx: { borderColor: "#F1F5F9", mb: 2.5 } }),
                    React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 13, fontWeight: 600, color: "#0f172a", mb: 2 } }, "Address Proof Documents"),
                    React.createElement(Grid, { container: true, spacing: 2.5, mb: 2.5 },
                        React.createElement(Grid, { item: true, xs: 4 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Document Type"),
                            React.createElement(Select, { value: documentType, variant: "outlined", displayEmpty: true, size: "small", readOnly: true, fullWidth: true, sx: { borderRadius: "8px", backgroundColor: "#F8FAFC", fontFamily: "Poppins", fontSize: 13 } },
                                React.createElement(MenuItem, { disabled: true, value: "" },
                                    React.createElement(Typography, { variant: "body2", sx: { color: "#94A3B8", fontFamily: "Poppins", fontSize: 13 } }, "Select document type")), documentsType === null || documentsType === void 0 ? void 0 :
                                documentsType.map((category, index) => (React.createElement(MenuItem, { key: index, value: category }, category))))),
                        React.createElement(Grid, { item: true, xs: 4 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Document ID"),
                            React.createElement(CustomTextField, { className: "AO_input_background", InputLabelProps: { shrink: false }, disabled: true, placeholder: "Enter document ID", fullWidth: true, name: "documentId", size: "small", value: documentId, sx: fieldSx })),
                        React.createElement(Grid, { item: true, xs: 4 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Name on Document"),
                            React.createElement(CustomTextField, { className: "AO_input_background", InputLabelProps: { shrink: false }, inputProps: { maxLength: 30, minLength: 2 }, disabled: true, placeholder: "Enter name on document", fullWidth: true, name: "documentName", size: "small", value: documentName, sx: fieldSx }))),
                    React.createElement(Grid, { container: true, spacing: 2.5 },
                        React.createElement(Grid, { item: true, xs: 4 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Front Image"),
                            renderFileChip(docFrontFileName, docFrontFileType)),
                        React.createElement(Grid, { item: true, xs: 4 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Back Image"),
                            renderFileChip(docBackFileName, docBackFileType)))))),
        React.createElement(Grid, { item: true },
            React.createElement(Box, { sx: { border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" } },
                React.createElement(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        px: 2.5,
                        py: 1.75,
                        backgroundColor: "#F8FAFC",
                        borderBottom: "1px solid #E2E8F0",
                    } },
                    React.createElement(Box, { sx: {
                            width: 36,
                            height: 36,
                            borderRadius: "9px",
                            backgroundColor: "#F0FDF4",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                        } },
                        React.createElement(AccountBalance, { sx: { fontSize: 18, color: "#16A34A" } })),
                    React.createElement(Box, null,
                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 14, fontWeight: 600, color: "#0f172a", lineHeight: 1.3 } }, "Bank Details"),
                        React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 11, color: "#64748B", lineHeight: 1.5 } }, "Linked bank account for remittance payouts"))),
                React.createElement(Box, { sx: { p: 2.5 } },
                    React.createElement(Grid, { container: true, spacing: 2.5 },
                        React.createElement(Grid, { item: true, xs: 6 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Beneficiary Name"),
                            React.createElement(CustomTextField, { className: "AO_input_background", InputLabelProps: { shrink: false }, inputProps: { maxLength: 30, minLength: 2 }, disabled: true, placeholder: "Enter full name", fullWidth: true, name: "beneficiaryName", size: "small", value: beneficiaryName, onChange: (e) => setBeneficiaryName(e.target.value), sx: fieldSx })),
                        React.createElement(Grid, { item: true, xs: 6 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Account Number"),
                            React.createElement(CustomTextField, { className: "AO_input_background", InputLabelProps: { shrink: false }, inputProps: { maxLength: 40, minLength: 4 }, disabled: true, placeholder: "XXXXXXXXXXXXX", fullWidth: true, name: "accountNumber", size: "small", value: accountNumber, onChange: (e) => setAccountNumber(e.target.value), sx: fieldSx })),
                        React.createElement(Grid, { item: true, xs: 6 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "IFSC Code"),
                            React.createElement(CustomTextField, { className: "AO_input_background", InputLabelProps: { shrink: false }, inputProps: { maxLength: 30, minLength: 2 }, disabled: true, placeholder: "Enter IFSC code", fullWidth: true, name: "ifscCode", size: "small", value: ifscCode, onChange: (e) => setIfscCode(e.target.value), sx: fieldSx })),
                        React.createElement(Grid, { item: true, xs: 6 },
                            React.createElement(Typography, { className: "tenant_key", mb: 0.5 }, "Bank Name"),
                            React.createElement(CustomTextField, { className: "AO_input_background", InputLabelProps: { shrink: false }, inputProps: { maxLength: 30, minLength: 2 }, disabled: true, placeholder: "Enter bank name", fullWidth: true, name: "bankName", size: "small", value: bankName, onChange: (e) => setBankName(e.target.value), sx: fieldSx }))))))));
};
export default KycDetailsForm;
